import React, { useState } from 'react';
import { FileDown, Filter } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { DatePicker } from '../../components/ui/DatePicker';
import { Select } from '../../components/ui/Select';
import { mockBatches } from '../../data/mockData';
export function ReportsPage() {
  const [activeTab, setActiveTab] = useState('transactions');
  const [statusFilter, setStatusFilter] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const tabs = [{
    id: 'transactions',
    label: 'Transaction Report'
  }, {
    id: 'users',
    label: 'User Activity'
  }, {
    id: 'audit',
    label: 'Audit Logs'
  }, {
    id: 'performance',
    label: 'Branch Performance'
  }];
  return <div className="space-y-6" data-id="element-618">
      <div className="flex items-center justify-between" data-id="element-619">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-620">
          Reports & Analytics
        </h2>
        <div className="flex space-x-2" data-id="element-621">
          <Button variant="outline" leftIcon={<FileDown className="w-4 h-4" data-id="element-623" />} data-id="element-622">
            Export PDF
          </Button>
          <Button variant="outline" leftIcon={<FileDown className="w-4 h-4" data-id="element-625" />} data-id="element-624">
            Export Excel
          </Button>
        </div>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200" data-id="element-626">
        <nav className="-mb-px flex space-x-8" data-id="element-627">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                ${activeTab === tab.id ? 'border-[#1B6B3A] text-[#1B6B3A]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
              `} data-id="element-628">
              {tab.label}
            </button>)}
        </nav>
      </div>

      {/* Filters */}
      <Card className="bg-gray-50" data-id="element-629">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-630">
          <DatePicker label="From Date" value={fromDate} onChange={e => setFromDate(e.target.value)} data-id="element-631" />
          <DatePicker label="To Date" value={toDate} onChange={e => setToDate(e.target.value)} data-id="element-632" />
          <Select label="Status" options={[{
          value: '',
          label: 'All Statuses'
        }, {
          value: 'Completed',
          label: 'Completed'
        }, {
          value: 'Pending',
          label: 'Pending'
        }, {
          value: 'Rejected',
          label: 'Rejected'
        }]} value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-633" />
          <div className="flex items-end" data-id="element-634">
            <Button className="w-full" leftIcon={<Filter className="w-4 h-4" data-id="element-636" />} data-id="element-635">
              Apply Filters
            </Button>
          </div>
        </div>
      </Card>

      {/* Results */}
      <Card title="Report Results" data-id="element-637">
        <DataTable columns={[{
        header: 'Date',
        accessor: b => new Date(b.uploadDate).toLocaleDateString()
      }, {
        header: 'Batch ID',
        accessor: 'id'
      }, {
        header: 'Branch',
        accessor: 'branchId'
      }, {
        header: 'Volume',
        accessor: b => `PKR ${b.totalAmount.toLocaleString()}`
      }, {
        header: 'Records',
        accessor: 'totalRecords'
      }, {
        header: 'Status',
        accessor: b => <StatusBadge status={b.status} size="sm" data-id="element-639" />
      }]} data={mockBatches} data-id="element-638" />
      </Card>
    </div>;
}